import { Bell, Globe, GraduationCap, MessageSquare, Settings, ShieldAlert, Users, Wallet } from "lucide-react";
import { NavLink } from "react-router-dom";
import { useConnect } from "../../connect/store";
import { Badge } from "./ui";

export const BottomNav = ({ vertical = false }) => {
  const { me, badges } = useConnect();
  const allTabs = [
    { to: "/connect/chats", label: "Chats", icon: MessageSquare, testid: "nav-tab-chats", n: badges.chats },
    { to: "/connect/directory", label: "Directory", icon: Users, testid: "nav-tab-directory" },
    { to: "/connect/group", label: "All Staff", icon: Globe, testid: "nav-tab-group" },
    { to: "/connect/activity", label: "Activity", icon: Bell, testid: "nav-tab-notifications", n: badges.notifications },
    { to: "/connect/settings", label: "Settings", icon: Settings, testid: "nav-tab-settings" },
  ];
  const tabs = allTabs.filter((t) => !(me?.directory_hidden && t.to === "/connect/directory"));
  if (me?.has_training) tabs.splice(tabs.findIndex((t) => t.to === "/connect/activity"), 0, { to: "/connect/training", label: "My Training", icon: GraduationCap, testid: "nav-tab-training" });
  if (me && !me.is_ceo) tabs.splice(tabs.findIndex((t) => t.to === "/connect/activity"), 0, { to: "/connect/pay", label: "My Pay", icon: Wallet, testid: "nav-tab-pay" });
  if (me?.is_ceo) tabs.push({ to: "/connect/admin", label: "CEO Admin", icon: ShieldAlert, testid: "nav-tab-admin", n: (badges.inbox || 0) + (badges.queue ? 1 : 0), gold: true });
  if (vertical) return (
    <nav className="shrink-0 w-[84px] bg-[#0a111e] border-r border-slate-800/80 flex flex-col items-stretch py-3 gap-1" data-testid="desktop-rail">
      {tabs.map((t) => (
        <NavLink key={t.to} to={t.to} data-testid={`${t.testid}-desktop`} className={({ isActive }) => `relative mx-2 rounded-2xl py-3 flex flex-col items-center gap-1 text-[10px] font-medium transition-colors ${isActive ? (t.gold ? "text-amber-300 bg-amber-500/10" : "text-blue-300 bg-blue-500/10") : "text-slate-400 hover:text-slate-200 hover:bg-white/5"}`}>
          {({ isActive }) => (<><span className="relative"><t.icon size={22} strokeWidth={isActive ? 2.4 : 1.8} /><span className="absolute -top-1.5 -right-2.5"><Badge n={t.n} gold={t.gold} /></span></span>{t.label}</>)}
        </NavLink>
      ))}
    </nav>
  );
  return (
    <nav className="shrink-0 h-16 bg-[#0a111e]/95 backdrop-blur-md border-t border-slate-800/80 grid" style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))`, paddingBottom: "env(safe-area-inset-bottom)" }} data-testid="bottom-nav">
      {tabs.map((t) => (
        <NavLink key={t.to} to={t.to} data-testid={t.testid}
          className={({ isActive }) => `relative flex flex-col items-center justify-center gap-0.5 text-[10px] font-medium transition-colors ${isActive ? (t.gold ? "text-amber-300" : "text-blue-400") : "text-slate-500 hover:text-slate-300"}`}>
          {({ isActive }) => (
            <>
              <span className={`absolute top-0 left-1/2 -translate-x-1/2 h-0.5 w-8 rounded-full transition-opacity ${isActive ? "opacity-100" : "opacity-0"} ${t.gold ? "bg-amber-400" : "bg-blue-500"}`} />
              <span className="relative">
                <t.icon size={21} strokeWidth={isActive ? 2.4 : 1.8} />
                <span className="absolute -top-1.5 -right-2.5"><Badge n={t.n} gold={t.gold} /></span>
              </span>
              {t.label}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
};
